import React, { useState } from "react"
import {
  Popover,
  Button,
  Typography,
  Box,
  Backdrop,
  useTheme,
} from "@mui/material"
import { ContactIcon, PhoneIcon } from "../icons"
import { useContact } from "extensions/bitec-buri/hooks/contact/useContact"
import { useTranslation } from "providers/i18n"

export const HelpCenterButton = () => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`HelpCenterButton`]?.styleOverrides || {}

  const { root, backDrop, infoContainer, contactContainer, headerContainer } =
    styleOverrides

  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
    setIsOpen(true)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setIsOpen(false)
  }

  const { helpCentre } = useContact()

  return (
    <>
      <Button
        variant="contained"
        onClick={handleClick}
        startIcon={<ContactIcon />}
        sx={root}
      >
        {t("Help Centre")}
      </Button>
      <Backdrop open={isOpen} sx={backDrop} onClick={handleClose} />
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{ sx: infoContainer }}
      >
        <Box sx={headerContainer}>
          <Typography variant="body2" color="textSecondary">
            {t(helpCentre?.descriptions)}
          </Typography>
        </Box>
        {helpCentre.contacts.map((contact, index) => (
          <Box sx={contactContainer} key={index}>
            <PhoneIcon />
            <Typography variant="body1">{contact}</Typography>
          </Box>
        ))}
      </Popover>
    </>
  )
}
